import { MedicationTypeDisplay } from '@quromedical/fhir-common';
import {
  MedicationGetAllResponse,
  MedicationMeasure,
  MedicationRepeat,
  MedicationRouteCode,
  MedicationRouteCodeDescription,
} from '@quromedical/models';
import { ColumnType } from 'components/table';
import { strings } from 'strings';

export interface MedicationTableData {
  name: string;
  nappiCode: string;
  strength: string;
  volume: string;
  route: string;
  repeat: string;
  type: string;
  id: string;
}

export const baseMedicationColumns: ColumnType<MedicationTableData>[] = [
  {
    header: strings.MedicationNameSubheading,
    accessor: 'name',
  } as ColumnType<MedicationTableData, 'name'>,
  {
    header: strings.MedicationNappiCodeSubheading,
    accessor: 'nappiCode',
  } as ColumnType<MedicationTableData, 'nappiCode'>,
  {
    header: strings.MedicationRepeatSubheading,
    accessor: 'repeat',
  } as ColumnType<MedicationTableData, 'repeat'>,
  {
    header: strings.MedicationStrengthSubheading,
    accessor: 'strength',
  } as ColumnType<MedicationTableData, 'strength'>,
  {
    header: strings.MedicationVolumeSubheading,
    accessor: 'volume',
  } as ColumnType<MedicationTableData, 'volume'>,
  {
    header: strings.MedicationRouteSubheading,
    accessor: 'route',
  } as ColumnType<MedicationTableData, 'route'>,
  {
    header: strings.MedicationTypeSubheading,
    accessor: 'type',
  } as ColumnType<MedicationTableData, 'type'>,
];

const getMeasureDisplay = (measure?: MedicationMeasure) => {
  if (!(measure?.value && measure?.unit)) {
    return strings.ValueNotAvailable;
  }
  return `${measure.value} ${measure.unit}`;
};

const getRepeatDisplay = (repeat?: MedicationRepeat) => {
  if (!repeat) {
    return strings.ValueNotAvailable;
  }
  const { frequency, period, periodUnit } = repeat;
  return `${frequency} / ${period} ${periodUnit}`;
};

const getRouteDescription = (route?: MedicationRouteCode) => {
  if (!route) {
    return strings.ValueNotAvailable;
  }

  return MedicationRouteCodeDescription[route];
};

export const getDataFromResponse = (
  res: MedicationGetAllResponse
): Partial<MedicationTableData>[] =>
  res.medicationUsages.map(p => ({
    id: p.id,
    name: p.medication.name,
    nappiCode: p.medication.nappiCode,
    repeat: getRepeatDisplay(p.dosage.timingRepeat),
    strength: getMeasureDisplay(p.medication.strength),
    volume: getMeasureDisplay(p.medication.volume),
    route: getRouteDescription(p.dosage.route),
    type: p.type ? MedicationTypeDisplay[p.type] : undefined,
    status: p.status,
  }));
